import * as React from 'react'
import { Base_Component } from '../Base/Base.ui.Component'

interface Props {
    heading: string
}

export class WF_ChooseWorkflowSection extends Base_Component<Props, {}> {
    public tryRender() {
        const { children, heading } = this.props
        return (
            <div className="WF_ChooseWorkflowSection">
                <div className="WF_ChooseWorkflowSection_heading">{heading}</div>
                <div className="WF_ChooseWorkflowSection_content">{children}</div>
            </div>
        )
    }
}
